/* This is to standardize how source System is dealt with */
export enum SourceSystemType {
  Advance, // PolicyCenter
  Legacy, // Classic i.e. AutoPlus
  Phoenix
}

export enum SourceSystem {
  ROME = 'Rome',
  POLICYCENTER = 'PolicyCenter',
  AUTOPLUS = 'AutoPlus',
  PHOENIX = 'CAHP_Connect_Phoenix',
  PROPERTYPLUS = 'PropertyPlus',
  UMBRELLA = 'LegacyUmbrella',
  HOMESITE = 'Homesite'
}

export enum UserAccountAPISourceSystem {
  ROME = 'PL_Rome',
  PLPC = 'PLPC',
  AUTOPLUS = 'PL_Auto_Plus',
  PROPERTYPLUS = 'PL_Property_Plus',
  UMBRELLA = 'PL_Umbrella'
}
